import * as React from "react";

/**
 * This is the entry in the list of DCFs that will be available to the user.
 */
export const SubjectIdItem = ({ recordId, isDisabled, onClick, correctionSelected, subjectDisplayText }): JSX.Element => {
    return (
        <li
            className="col-md-6"
            style={{ paddingLeft: 5 + "px", paddingRight: 5 + "px" }}
            onClick={isDisabled ? null : onClick}>
            <input type="radio" name={`SubjectId${recordId}`} value="true" checked={correctionSelected} readOnly disabled={isDisabled} />
            <label>
                <span className="posh-select-icon"><i className="fa fa-edit" aria-hidden="true"></i></span>
                <span className="posh-select-body">
                    <span className="posh-select-title">Change {subjectDisplayText}</span>
                    <span className="posh-select-description text-muted">Change the {subjectDisplayText} for a single subject.</span>
                </span>
            </label>
        </li>
    );
}
